import { render, staticRenderFns } from "./companyDialog.vue?vue&type=template&id=0f22e1b8&scoped=true"
import script from "./companyDialog.vue?vue&type=script&lang=js"
export * from "./companyDialog.vue?vue&type=script&lang=js"
import style0 from "./companyDialog.vue?vue&type=style&index=0&id=0f22e1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22e1b8",
  null
  
)

export default component.exports